//CONFLICT: entire code from phase2 was picked.
import { Component, OnChanges, Input, Output, EventEmitter, ViewChild, OnDestroy, TemplateRef, OnInit } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { ProductPackage } from '../Models/productPackage';
import { SOPRoutines } from '../Models/SOPRoutines';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { fiveMomentsMap } from '../ph-bhp-asepticprocedures.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'lib-ph-bhp-dashboard',
    templateUrl: './ph-bhp-dashboard.component.html',
    styleUrls: ['./ph-bhp-dashboard.component.css']
})
export class PhBhpDashboardComponent implements  OnInit, OnChanges, OnDestroy {

    subscription: Subscription;
    institutionSubscription: Subscription;
    @Input() userData;
    @Output() childData = new EventEmitter();
    @Input() isDesktop = false;
    @ViewChild('chart') chart;
    @ViewChild('chartMoments') chartMoments;
    @ViewChild('chartOverall') chartOverall;
    @ViewChild('quotasChart') quotasChart;
    @ViewChild('pieChart') pieChart;
    @ViewChild('wardsMatching') wardsMatchingModal: TemplateRef<any>;

    maxDate = new Date();
    initFlag = true;
    showApply = false;
    dateRange = [];
    tab = 'week';
    packageID = 0;
    tempPackageID = 0;
    observeObservations;
    isAdjustableHeight = true;

    sopRoutines: Array<SOPRoutines>;
    consumptions;
    consumptionMeasurement;
    institutions;
    sopObservations;
    roleId = 1;
    countryList;
    selectedCountry = 0;
    selectedInstitution = 0;
    institutionsList;
    public range = {
        start: new Date(),
        end: new Date()
    }
    departmentList: any;
    selectedDepartmentID;
    selectedDepartmentName;
    progressQuotaCount;
    noQuotaData
    fiveMomentsMap: any[];
    overallComplianceMap: any[];
    positiveComplianceCount = 0;
    translationKeys: typeof TranslationKeys = TranslationKeys;
    modalRef: BsModalRef;
    institutionWards:any[];
    fields: any[];
    selectedInstitutionName: string;

    constructor(
        private service: PHBHPFeaturePackageEvaluationService,
        public layoutService: PHBHPLayoutPackageService
        ) {
        this.fiveMomentsMap = fiveMomentsMap;
    }
    ngOnInit(): void {
        this.layoutService.institutionIDSubject.subscribe((institutionId) => {
            if(this.institutionsList){
                this.onInstitutionChange(institutionId, '');
            }
        });
        this.selectedInstitutionName =  this.layoutService.dashboardSelectedInstitutionName;
    }

    ngOnChanges() {
        // this.fiveMomentsMap.forEach(el => el.short = this.data.translatetext(el.short));
        if (this.userData) {
            this.roleId = this.userData.roleName.roleId;
            if(this.roleId !=1 && this.roleId !=2)
            {
                this.range.start = new Date(this.range.end.getTime() - (7 * 24 * 60 * 60 * 1000));
                this.dateRange = [this.range.start, this.range.end]

                if (this.layoutService.dashboardSelectedInstitution) {
                    this.selectedInstitution = this.layoutService.dashboardSelectedInstitution;
                    if(this.institutionsList && this.institutionsList.length > 0){
                        this.selectedInstitutionName = this.institutionsList.find(inst => inst.institution.institution.institutionID == this.selectedInstitution).institution.institution.institutionName;
                    }
                    this.getDepartmentsByInstitutionId();
                }
                if (this.roleId == 1) {
                    this.getCountryList()
                } else {
                    this.getUsersInstitutions();
                }

                //this.InitFun();
                this.onDateChange(this.range.start, this.range.end);
                if (this.initFlag) {
                    this.initFlag = false;
                }

                this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
                    // this.fiveMomentsMap.forEach(el => el.short = this.data.translatetext(el.short));
                    this.onDateChange(this.range.start, this.range.end);
                });

                this.institutionSubscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
                    this.onDateChange(this.range.start, this.range.end);
                    if (this.chart) this.chart.ngOnInit();
                    if (this.chartMoments) this.chartMoments.ngOnInit();
                    if (this.chartOverall) this.chartOverall.ngOnInit();
                    if (this.pieChart) this.pieChart.ngOnInit();
                });
            }
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

        if (this.institutionSubscription) {
            this.institutionSubscription.unsubscribe();
        }
    }

    isSOP() {
        return this.packageID == 1 || this.packageID == 3 || this.packageID == 5 || this.packageID == 7;
    }

    isCheck() {
        return this.packageID == 4 || this.packageID == 5 || this.packageID == 6 || this.packageID == 7;
    }

    isObserve() {
        return this.packageID == 2 || this.packageID == 3 || this.packageID == 6 || this.packageID == 7;
    }

    onInstitutionChangeFront(institutionID, institutionName) {
        this.layoutService.dashboardSelectedInstitution = institutionID;
        this.layoutService.dashboardSelectedInstitutionName = institutionName;
        this.selectedInstitutionName = institutionName;
        this.onInstitutionChange(institutionID, institutionName);
    }

    onInstitutionChange(institutionID, institutionName) {
        this.selectedInstitution = institutionID;
        if(!institutionName){
            institutionName = this.institutionsList.find(inst => inst.institution.institution.institutionID == institutionID).institution.institution.institutionName;
        }
        this.selectedInstitutionName = institutionName;
        if (this.roleId == 3) {
            let filteredGroup = this.institutionsList.filter(el => el.institution.institution.isGroup == true);
            if (filteredGroup[0].institution.institution.institutionID == this.selectedInstitution) {
                this.ngOnChanges();
            } else {
                if (institutionID != 0) {
                    var institutionDetail = this.institutionsList.find(inst => inst.institution.institution.institutionID == institutionID);
                    this.packageID = institutionDetail.institution.institution.packageID;
                    this.getDepartmentsByInstitutionId()
                } else {
                    this.packageID = this.tempPackageID;
                    this.departmentList = null;
                    this.selectedDepartmentID = 0;
                    this.selectedDepartmentName = '';
                }
                //var userID = this.userData.userId
                this.onDateChange(this.range.start, this.range.end);
            }
        } else {
            if (institutionID != 0) {
                var institutionDetail = this.institutionsList.find(inst => inst.institution.institution.institutionID == institutionID);
                this.packageID = institutionDetail.institution.institution.packageID;
                this.getDepartmentsByInstitutionId()
            } else {
                this.packageID = this.tempPackageID;
                this.departmentList = null;
                this.selectedDepartmentID = 0;
                this.selectedDepartmentName = '';
            }
            //var userID = this.userData.userId
            this.onDateChange(this.range.start, this.range.end);
        }

        this.onDateChange(this.range.start, this.range.end);
        if (this.chart) this.chart.ngOnInit();
        if (this.chartMoments) this.chartMoments.ngOnInit();
        if (this.chartOverall) this.chartOverall.ngOnInit();
        if (this.pieChart) this.pieChart.ngOnInit();
    }

    onDepartmentChange(department) {
      if (department){
        this.selectedDepartmentID = department.departmentID;
        this.selectedDepartmentName = department.departmentName;
        this.getQuotasDetail();
      } else {
        this.selectedDepartmentID = 0;
        this.selectedDepartmentName = '';
      }
    }

    testCall() {
        this.showApply = true;
    }

    testCall2() {
        this.showApply = false;

    }

    getDepartmentsByInstitutionId() {
        if (this.isObserve) {
            this.service.getDepartmentsByInstitutionId(this.selectedInstitution).subscribe((res: any) => {
                if (res) {
                    this.departmentList = res.departments;
                    if (this.departmentList) {
                        this.selectedDepartmentID = this.departmentList[0].departmentID;
                        this.selectedDepartmentName = this.departmentList[0].departmentName;
                        this.getQuotasDetail();
                    }

                    // if (this.choosenInstitutionIDDropDown !== 0) {
                    // this.getQuotasDetail();
                    // } else {
                    // this.noQuotaData = true;
                    // }
                } else {
                    //this.noQuotaData = true;
                }
            });
        }
    }
    onCountryChange(CountryId) {
        this.selectedCountry = CountryId;
        //var userID = this.userData.userId
        this.onDateChange(this.range.start, this.range.end);
    }
    getDate() {
        this.tab = 'custom';
        this.onDateChange(this.range.start, this.range.end);
    }

    dateTab(tab) {
        this.range.end = new Date();
        switch (tab) {
            case 'today':
                this.tab = 'today';
                this.range.start = new Date(this.maxDate.getFullYear(), this.maxDate.getMonth(), this.maxDate.getDate());
                this.range.end = this.maxDate;
                //this.range.start = new Date(this.range.end.getTime() - (1 * 24 * 60 * 60 * 1000));
                this.dateRange = [this.range.start, this.range.end]
                this.onDateChange(this.range.start, this.range.end);
                break;
            case 'week':
                this.tab = 'week';
                this.range.start = new Date(this.maxDate.getTime() - (7 * 24 * 60 * 60 * 1000));
                this.range.end = this.maxDate;
                this.dateRange = [this.range.start, this.range.end]
                this.onDateChange(this.range.start, this.range.end);
                break;
            case 'month':
                this.tab = 'month';
                this.range.start = new Date(this.maxDate.getTime() - (30 * 24 * 60 * 60 * 1000));
                this.range.end = this.maxDate;
                this.dateRange = [this.range.start, this.range.end]
                this.onDateChange(this.range.start, this.range.end);
                break;
        }
    }
    selectDate() {
        this.range.start = this.dateRange[0]
        this.range.end = this.dateRange[1]
        this.tab = 'custom';
        this.onDateChange(this.range.start, this.range.end);
    }

    getCountryList() {
        var getCountry: Observable<Array<any>> = this.service.getCountry();
        var getCountryList: Observable<Array<any>> = this.service.getCountryList();

        forkJoin([getCountry, getCountryList]).subscribe(([countryRes, countryListRes]) => {
            // countryRes.forEach((country, index) => {

            //     var countryName = countryListRes.find((list) => list.countryID == country.countryID).countryName;
            //     countryRes[index].countryName = countryName;
            // })
            this.countryList = countryRes
        })
    }
    getUsersInstitutions() {
        this.service.getUsersInstitutions(this.userData).subscribe((res) => {
            this.institutionsList = res.filter((ins) => this.roleId > 2 ? ins.institution.institution.status : true);
            this.selectedInstitutionName = 'SOP_MANAGEMENT.ALL';
            if (this.institutionsList.length == 1) {
                this.selectedInstitution = this.institutionsList[0].institution.institution.institutionID;
                this.selectedInstitutionName = this.institutionsList[0].institution.institution.institutionName;
                this.getDepartmentsByInstitutionId();
            }
            //this.packageType();
            if (this.roleId === 3) {
                let filteredGroup = res.filter(el => el.institution.institution.isGroup == true);
                this.selectedInstitution = filteredGroup[0].institution.institution.institutionID;
                this.selectedInstitutionName = filteredGroup[0].institution.institution.institutionName;
                this.onDateChange(this.range.start, this.range.end);
                //this.selectedInstitution = res[0].institution.institution.institutionID;
            }
        })
    }

    packageType() {
        var isObserve = false;
        var isSOP = false;
        this.institutionsList.forEach(inst => {
            if (inst.institution.institution.packageID == 3) {
                isObserve = true;
                isSOP = true;
            } else if (inst.institution.institution.packageID == 2) {
                isObserve = true;
            } else if (inst.institution.institution.packageID == 1) {
                isSOP = true;
            }
            if (isObserve && isSOP)
                return;
        });
        if (isObserve && isSOP) {
            this.packageID = 3;
            this.tempPackageID = 3;
        } else if (isObserve) {
            this.packageID = 2;
            this.tempPackageID = 2;
        } else {
            this.packageID = 1;
            this.tempPackageID = 1;
        }
    }

    getProductPackageDetails(countryId = null, data) {
        if (countryId == null || countryId == 0) {
            var productPackageDetails = this.service.GetProductPackageDetails(data);
        } else {
            data.countryID = countryId;
            var productPackageDetails = this.service.GetProductPackageDetailsByCountryId(data);
        }
        productPackageDetails.subscribe((res: Array<ProductPackage>) => {
            if(this.pieChart){
                var data = JSON.parse(JSON.stringify(this.pieChart.productPackageChart));
                data.categoryAxis.categories = []
                data.series[0].data = []
                res.forEach((value, index) => {
                    data.series[0].data.push({
                        category: this.layoutService.translateText(value.packageName),
                        value: (value.packagePercentage > 0) ? (value.packagePercentage + "%") : value.packagePercentage
                    });
                    if (index == 0) {
                        data.series[0].data[index].color = "#1a237e"
                    } else if (index == 1) {
                        data.series[0].data[index].color = "#303f9f"
                    } else if (index == 2) {
                        data.series[0].data[index].color = "#4a64b4"
                    }
                    data.categoryAxis.categories.push(this.layoutService.translateText(value.packageName));
                })
                this.pieChart.productPackageChart = data;
            }
        })
    }

    showInstitutionDropDown() {
        if (this.institutionsList) {
            if (this.institutionsList.length < 2) {
                return false;
            } else {
                return true;
            }
        }
    }

    getInstitutionName() {
        if (this.institutionsList && this.institutionsList[0] && this.institutionsList[0].institution) {
            this.selectedInstitution = this.institutionsList[0].institution.institution.institutionID;
            this.selectedInstitutionName = this.institutionsList[0].institution.institution.institutionName;
            this.packageID = this.institutionsList[0].institution.institution.packageID;
            //this.getDepartmentsByInstitutionId();
            return this.institutionsList[0].institution.institution.institutionName;
        }
    }

    overallCompliance(compliance) {
        if (this.chartOverall) {
            this.positiveComplianceCount = compliance.positiveComplaint;
            var data = JSON.parse(JSON.stringify(this.chartOverall.chartOptions || {}));
            var overallCompliance = compliance.positiveComplaint + '% '+ this.layoutService.translateText(this.translationKeys.Dashboard.ComplianceOf)+ ' ' + this.observeObservations  +' '+this.layoutService.translateText(this.translationKeys.Dashboard.Opportunities);//this.data.translatetext('DASHBOARD.OVERALL_COMPLIANCE');
            data.series[0].name = [overallCompliance];
            data.series[0].data = [
                compliance.positiveComplaint,
            ];

            data.series[0].data.forEach((value, index) => {
                if (isNaN(data.series[0].data[index])) {
                    data.series[0].data[index] = 0;
                }
            });
            this.chartOverall.chartOptions = data;
            this.chartOverall.chartDatamani();
        }
    }

    fiveMoments(fiveMomentsCount) {
        if (this.chartMoments) {
            var dataMoments = JSON.parse(JSON.stringify(this.chartMoments.chartOptions));
            var Moments = this.layoutService.translateText(this.translationKeys.Dashboard.FiveMoments);
            dataMoments.series[0].name = [Moments];
            dataMoments.categoryAxis.categories = [
                this.layoutService.translateText(fiveMomentsMap[0].short),
                this.layoutService.translateText(fiveMomentsMap[1].short),
                this.layoutService.translateText(fiveMomentsMap[2].short),
                this.layoutService.translateText(fiveMomentsMap[3].short),
                this.layoutService.translateText(fiveMomentsMap[4].short),
            ]
            dataMoments.series[0].data = [
                // Math.round((fiveMomentsCount[fiveMomentsMap[0].key] * 100) / this.observeObservations),
                // Math.round((fiveMomentsCount[fiveMomentsMap[1].key] * 100) / this.observeObservations),
                // Math.round((fiveMomentsCount[fiveMomentsMap[2].key] * 100) / this.observeObservations),
                // Math.round((fiveMomentsCount[fiveMomentsMap[3].key] * 100) / this.observeObservations),
                // Math.round((fiveMomentsCount[fiveMomentsMap[4].key] * 100) / this.observeObservations)
                fiveMomentsCount[fiveMomentsMap[0].key],
                fiveMomentsCount[fiveMomentsMap[1].dashboardKey],
                fiveMomentsCount[fiveMomentsMap[2].key],
                fiveMomentsCount[fiveMomentsMap[3].key],
                fiveMomentsCount[fiveMomentsMap[4].key]
            ];

            dataMoments.series[0].data.forEach((value, index) => {
                if (isNaN(dataMoments.series[0].data[index])) {
                    dataMoments.series[0].data[index] = 0;
                }
            })

            dataMoments.categoryAxis.rotation = 0;
            dataMoments.categoryAxis.maxDivisions = 10;
            this.chartMoments.chartOptions = dataMoments;
            this.chartMoments.chartDatamani();
            // this.fiveMomentsMap.forEach(el => el.short = this.data.translatetext(el.short));
            this.chartMoments.findTooltipText = (truncatedText) => {
                const translateTruncated = this.layoutService.translateText(truncatedText);
                const tooltip = this.fiveMomentsUsingKeys(translateTruncated, 'short')
                    ? this.layoutService.translateText(this.fiveMomentsUsingKeys(translateTruncated, 'short').name) : '';
                return tooltip;
            };
        }
    }

    fiveMomentsUsingKeys(shortName,key){
        if(shortName != 0)
            return this.fiveMomentsMap.find(res=>this.layoutService.translateText(res[key]) == shortName);
        return null;
    }

    mapQuotasValueToChart(data) {
        if (data.totalQuotas === 0) {
            this.noQuotaData = true;
        } else {
            this.progressQuotaCount = data.progressQuotas;
            this.quotasChart.productPackageChart.donutCenterText.enable = true;
            this.quotasChart.productPackageChart.donutCenterText.value = data.totalQuotas;
            this.quotasChart.productPackageChart.donutCenterText.text = this.layoutService.translateText('Quotas');
            //   this.quotasChart.chartOptions.startAngle = 330;
            //   this.quotasChart.chartOptions.toolTip.showAsPercentage = true;

            var quotadata = JSON.parse(JSON.stringify(this.quotasChart.productPackageChart));
            quotadata.categoryAxis.categories = [
                this.layoutService.translateText(fiveMomentsMap[0].name),
                this.layoutService.translateText(fiveMomentsMap[1].name),
                this.layoutService.translateText(fiveMomentsMap[2].name),
                this.layoutService.translateText(fiveMomentsMap[3].name),
                this.layoutService.translateText(fiveMomentsMap[4].name)
            ];
            quotadata.series[0].data = [
                {
                    category: this.layoutService.translateText(fiveMomentsMap[0].name),
                    //value: Math.round((data.fiveMomentsCount.beforeTouchingPatient * 100) / data.totalQuotas),
                    value: data.fiveMomentsCount.beforeTouchingPatient,
                    color: '#1a237e'
                },
                {
                    category: this.layoutService.translateText(fiveMomentsMap[1].name),
                    //value: Math.round((data.fiveMomentsCount.beforeAsepticProcedures * 100) / data.totalQuotas),
                    value: data.fiveMomentsCount.beforeAsepticProcedures,
                    color: '#303f9f'
                },
                {
                    category: this.layoutService.translateText(fiveMomentsMap[2].name),
                    //value: Math.round((data.fiveMomentsCount.afterBodyFluidExposure * 100) / data.totalQuotas),
                    value: data.fiveMomentsCount.afterBodyFluidExposure,
                    color: '#4a64b4'
                },
                {
                    category: this.layoutService.translateText(fiveMomentsMap[3].name),
                    //value: Math.round((data.fiveMomentsCount.afterTouchingPatient * 100) / data.totalQuotas),
                    value: data.fiveMomentsCount.afterTouchingPatient,
                    color: '#5e76c2'
                },
                {
                    category: this.layoutService.translateText(fiveMomentsMap[4].name),
                    //value: Math.round((data.fiveMomentsCount.afterTouchingPatientSurroundings * 100) / data.totalQuotas),
                    value: data.fiveMomentsCount.afterTouchingPatientSurroundings,
                    color: '#7990d8'
                }];
            if ((data.totalQuotas - data.progressQuotas) > 0) {
                quotadata.series[0].data.splice(0, 0,
                    {
                        category: '',
                        //value: Math.round(((data.totalQuotas - data.progressQuotas) * 100) / data.totalQuotas),
                        value: (data.totalQuotas - data.progressQuotas),
                        color: '#fff'
                    }
                );
                quotadata.categoryAxis.categories.splice(0, 0, "");
            }
            quotadata.seriesDefaults["border"] = { width: 2, color: '#7990d8', opacity: 0.5 };
            quotadata.seriesDefaults.labels.format = "{0}";
            this.quotasChart.productPackageChart = quotadata;
        }
    }
    getQuotasDetail() {
        var userID = this.userData.userId;
        var institutionId = this.selectedInstitution;
        this.noQuotaData = false;
        this.service.getQuotasDetail(userID, institutionId, this.selectedDepartmentID).subscribe(res => {
            this.mapQuotasValueToChart(res);
        })
    }
    onDateChange(from: Date, to: Date) {
        from.setHours(0, 0, 0, 0);
        to.setHours(23, 59, 59, 999);
        var institutionId = 0;
        var countryID = this.selectedCountry;
        if (this.roleId == 2)
            countryID = this.userData.country;
        var userID = this.userData.userId;

        institutionId = this.layoutService.dashboardSelectedInstitution;


        var data = {
            "countryID": countryID,
            "institutionId": institutionId,
            "filter": {
                "startDate": from.toISOString(),
                "endDate": to.toISOString()
            }
        }

        //var sopDashBoard = this.service.getSOPDashBoardFilterList(userID, data);
        var dashBoard = this.service.getCompletePackageList(userID, data);
        var sopRoutines = this.service.GetTopSOPRoutinesFilter(userID, data);
        this.layoutService.showLoader = true;
        forkJoin([dashBoard, sopRoutines]).subscribe(([dashBoardRes, sopRoutinesRes]) => {
            this.layoutService.showLoader = false;
            this.packageID = dashBoardRes.packageType;
            var sopDashboardList = dashBoardRes.sopDashboardList;
            this.consumptions = dashBoardRes.consumptionInstitutionCount.consumptions;
            this.institutions = dashBoardRes.consumptionInstitutionCount.institutions;
            this.consumptionMeasurement = dashBoardRes.consumptionInstitutionCount.consumptionMeasurement;
            if (this.isSOP() && (this.roleId != 1 && this.roleId != 2)) {
                this.sopObservations = sopDashboardList.sopObservations;
                this.sopRoutines = sopRoutinesRes;
                if (this.chart) {
                    var data = JSON.parse(JSON.stringify(this.chart.chartOptions));
                    var ProcessName = this.layoutService.translateText('DASHBOARD.PROCESS');
                    data.series[0].name = [ProcessName]
                    data.series[0].data = [];
                    data.categoryAxis.categories = []
                    sopRoutinesRes.forEach((value) => {
                        data.series[0].data.push(value.processCompliancePercentage);
                        data.categoryAxis.categories.push(this.layoutService.translateText(value.sopName));
                    });
                    data.categoryAxis.rotation = 0;
                    data.categoryAxis.maxDivisions = 10;
                    this.chart.chartOptions = data;
                    this.chart.chartDatamani();
                }
            }
            if (this.isDesktop && (this.isObserve()) && (this.roleId != 1 && this.roleId != 2)) {
                var observeDashboardList = dashBoardRes.observeDashboardList;
                this.observeObservations = observeDashboardList.observeObservations;
                var fiveMomentsCount = observeDashboardList.fiveMomentsCount;
                var complainsCount = observeDashboardList.complainsCount;
                this.fiveMoments(fiveMomentsCount);
                this.overallCompliance(complainsCount);
            }
        })
        if (this.roleId == 1)
            this.getProductPackageDetails(this.selectedCountry, data)
        else if (this.roleId == 2)
            this.getProductPackageDetails(this.userData.country, data)
    }

}
